'use client'

import {Button, SanityImage, SlideshowNative} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {useRef, useState} from 'react'

export const MerchHeroSlideshow = ({images}) => {
	const slideshowRef = useRef<HTMLDivElement>(null)
	const [activeIndex, setActiveIndex] = useState<number>(0)

	const handleIndex = (index) => {
		if (slideshowRef.current) {
			slideshowRef.current.scrollToIndex(index)
		}
	}
	const handleChange = (index) => {
		if (index === activeIndex) return
		setActiveIndex(index)
	}

	return (
		<div className='relative lg-max:aspect-square lg:h-full overflow-clip'>
			<SlideshowNative
				ref={slideshowRef}
				onChange={handleChange}
				withDotNavigation
				dotNavigationClassName={cx(
					'absolute bottom-20 left-1/2 -translate-x-1/2 justify-center gap-14',
					'[&>button]:w-34 [&>button]:bg-white',
					'lg:hidden',
				)}
				className='h-full'
				containerClassName='h-full'>
				{images.map((image, index) => (
					<figure
						key={`images-${index}`}
						className='relative w-full h-full'>
						<SanityImage
							image={image}
							width={375}
							height={375}
							mobileWidth={375}
							mobileOnly
							className='object-cover w-full h-full'
							priority={index === 0}
							fill />
						<SanityImage
							image={image}
							width={967}
							height={900}
							mobileWidth={967}
							className='span-w-8-wider object-cover h-full'
							priority={index === 0}
							fill />
					</figure>
				))}
			</SlideshowNative>
			<div className='lg-max:hidden absolute bottom-20 left-1/2 -translate-x-1/2 flex flex-row gap-9'>
				{images.map((image, index) => (
					<Button
						key={`images-nav-${index}`}
						onClick={() => handleIndex(index)}>
						<SanityImage
							image={image}
							width={50}
							height={60}
							mobileWidth={50}
							desktopOnly
							className={cx(
								'w-50 h-60 object-cover rounded-xs',
								'border border-transparent',
								index === activeIndex && 'border-black',
							)} />
					</Button>
				))}
			</div>
		</div>
	)
}
